import { TemplateType } from '@debbie/common/dist/templates/index.js';
import { getMentionSuggestions, toEditorMentions, } from '@debbie/common/dist/templates/suggestions.js';
import { h } from '@debbie/cortex/dist/index.js';
import { usePropertyTypes } from '@debbie/cortex/dist/properties/index.js';
import { useTenant } from '@debbie/cortex/dist/tenant/index.js';
import React from 'react';
import { useSelector } from 'react-redux';
import { parseText } from '../../../../../utils/templates.js';
import NewEditor from '../../../../editor/Editor.js';
import { Col, Row } from '../../../../Grid/index.js';
const BPDescInput = (props) => {
    const lang = useSelector((s) => s.lang);
    const tenant = useTenant();
    const propertyTypesLoadable = usePropertyTypes();
    const propertyTypes = h.hasData(propertyTypesLoadable)
        ? propertyTypesLoadable.data
        : undefined;
    const mentionSuggestions = getMentionSuggestions(lang, TemplateType.LETTER, propertyTypes || undefined, tenant);
    const setBPDesc = (content) => {
        const bpDesc = parseText(content, mentionSuggestions);
        props.setDocumentState({ bpDesc });
    };
    return (React.createElement(Row, null,
        React.createElement(Col, { width: "12" },
            React.createElement("h3", null, "Rubrik 4"),
            React.createElement(NewEditor, { mentions: toEditorMentions(mentionSuggestions), onChange: (html) => {
                    props.editorState.onChange(html);
                    setBPDesc(html);
                }, initialContent: props.editorState.editorContent }))));
};
export default BPDescInput;
//# sourceMappingURL=BPDescInput.js.map